export class Attribute {
  id: number
  name: string
  attributeType: string
  attributeGroup: string
  ownerType: string
  ownerId: number
  longValue: number
  floatValue: number
  stringValue: string
  booleanValue: boolean
  dateValue: Date
  value: string
  referenceType: string
  referenceId: number
  public static copyFrom(source: Attribute, target: Attribute): void {
    target.id = source.id
    target.booleanValue = source.booleanValue
    target.stringValue = source.stringValue
    target.longValue = source.longValue
    target.dateValue = source.dateValue
    target.value = source.value
    target.referenceId = source.referenceId
    target.referenceType = source.referenceType
    target.floatValue = source.floatValue
  }
}
